// extracted by mini-css-extract-plugin
export default {"container":"RobotListPage_container__1kpEz"};